import React, { useContext } from "react";
import { AppContext } from "../AppContext";
import BuilderCard from "./BuilderCard";

const TopBuilders = () => {
  const { activeTab, selectedLocation } = useContext(AppContext);

  return (
    <div className="mt-8 p-4 bg-white shadow-md rounded-lg">
      <h2 className="text-3xl font-semibold text-gray-800">
        <span className="text-primaryOrange">Top Builders</span> in {selectedLocation}
      </h2>
      {/* Add deal content here */}
      <p className="text-gray-600 mt-2">Explore the best deals curated for you!</p>
      <BuilderCard/>
    </div>
  );
};

export default TopBuilders;

// {activeTab === "buy" ? "Buying" : "Rents"}